import { CSSProperties } from '../styles.interfaces';

export interface DynamicBannerStyleProperties {
  banner?: CSSProperties;
  heading?: CSSProperties;
  description?: CSSProperties;
  moreinfo?: CSSProperties;
  textPosition?: CSSProperties;
  badge?: CSSProperties;
}
